<div class="content-option-rows">
  <div class="content-option-row">
    <div class="content-option-row-label" translate>Every</div>
    <rotec-number-input-panel-v2
      class="number-input-panel"
      [darkMode]="true"
      [min]="1"
      [value]="interval"
      (valueChange)="intervalChange($event)"
    >
    </rotec-number-input-panel-v2>
    <div class="label-spacing" translate>Week(s) at</div>
  </div>
  <div class="button-row">
    <rotec-button-list-v2
      [darkMode]="true"
      [nrItemsPerRow]="4"
      [items]="daysOfWeekOptions"
      [selected]="daysOfWeek"
      (selectedChange)="daysOfWeek = $event"
    ></rotec-button-list-v2>
  </div>
</div>
